import { empty } from "gamla";

export const isUuid = (str: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);

export const apiTokenPrefix = "f0mo";

const toHex = (bytes: Uint8Array) =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

export const sha256Hex = (text: string) =>
  crypto.subtle.digest("SHA-256", new TextEncoder().encode(text)).then(
    (buffer) => toHex(new Uint8Array(buffer)),
  );

export const newApiTokenSecret = () =>
  toHex(crypto.getRandomValues(new Uint8Array(32)));

export const formatApiToken = (id: string, secret: string) =>
  `${apiTokenPrefix}_${id}_${secret}`;

export const parseApiToken = (token: string) => {
  const clean = token.replace(/^(f0mo_|tok_|svc\.)/, "");
  const parts = clean.includes("_") ? clean.split("_") : clean.split(".");
  const [id, secret, ...rest] = parts;
  return id && isUuid(id) && secret && secret.length === 64 && empty(rest)
    ? { id, secret }
    : null;
};

export const formatTokenIdentity = (raw: string) => {
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (
    trimmed.startsWith("service:") ||
    trimmed.startsWith("+") ||
    /^\d+$/.test(trimmed) ||
    isUuid(trimmed)
  ) {
    return trimmed;
  }
  return `service:${trimmed}`;
};

export type StoredApiToken = {
  userId: string;
  name: string;
  description?: string;
  secretHash: string;
  unlimitedQuota?: boolean;
  createdAt: number;
  createdBy?: string;
};

export type VerifiedApiToken = {
  userId: string;
  isSupertoken: boolean;
};

export const verifyStoredApiToken =
  (lookup: (id: string) => Promise<StoredApiToken | undefined>) =>
  async (token: string): Promise<VerifiedApiToken | null> => {
    const parsed = parseApiToken(token);
    if (!parsed) return null;
    const [stored, secretHash] = await Promise.all([
      lookup(parsed.id),
      sha256Hex(parsed.secret),
    ]);
    return stored && stored.secretHash === secretHash
      ? {
        userId: stored.userId,
        isSupertoken: Boolean(stored.unlimitedQuota),
      }
      : null;
  };
